export async function getCountryCodeFromIpInfo() {
  const token = process.env.GATSBY_IP_INFO_TOKEN;
  if (!token) return null;

  try {
    const response = await fetch(`https://ipinfo.io/json?token=${token}`);
    const data = await response.json();
    return data?.country?.trim()?.toUpperCase() || "IN";
  } catch (err) {
    return null;
  }
}
